import React from "react";
import './portfolio.scss';
import { Link } from "react-router-dom";
import Card from "./card";

const Portfolio: React.FC = () => {
  return (
    <>
      <section className="portfolio container" id="portfolio-section">
        <div className="wrapper">
          <h1>Portfolio projects</h1>
          <div className="description">
            <span>Every project is like a new little story: </span>
            <br></br>
            <span>Unique starting points and tasks, but all with a happy end.</span>
          </div>
          <div className="card-container">
                <Card size="medium" title="Brembo" subtitle="Website Redesign" link={"/brembo"}/>
                <Card size="small" title="MXE" subtitle="Revving Up Customers’ Imagination" link={"/mxe"}/>
                <Card size="large" title="BeCharge + Plenitude" subtitle="Placing new charging hubs around Europe" link={"/becharge"}/>
                <Card size="medium" title="Soilcast" subtitle="A Smart Irrigation System" link={"/soilcast"}/>
                <Card size="small" title="SPOAT" subtitle="Revolutionary network to find new talents" link={"/spoat"}/>
                 
            </div>
        </div>
      </section>
    </>
  );
};

export default Portfolio;